import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { ForgotContext } from '../../contexts/ForgotContext';
import { ForgotStep1 } from './ForgotStep1';
import { ForgotStep2 } from './ForgotStep2';
import { ForgotStep3 } from './ForgotStep3';
import { RegisterContext } from '../../contexts/RegisterContext';
import { LoginBlocked } from '../../components/LoginBlocked';

type ForgotContentContainerProps = {
	loading: boolean;
};

const ForgotContentContainer = styled.div<ForgotContentContainerProps>`
	width: 100%;
	max-width: 520px;
	margin: 0 auto;
	opacity: ${(props) => (props.loading ? 0.5 : 1.0)};
	pointer-events: ${(props) => (props.loading ? 'none' : 'auto')};

	.message {
		margin-bottom: 20px;
		font-size: 20px;
		text-align: center;
	}

	.alert {
		text-align: center;
	}
`;

export const ForgotContent: React.FC = () => {
	const { loginBlockedReason } = useContext(RegisterContext);
	const { loading, step } = useContext(ForgotContext);

	const ActiveForgotStep = useMemo(() => {
		if (loginBlockedReason) {
			return <LoginBlocked reason={loginBlockedReason} />;
		}

		switch (step) {
			case 1:
				return <ForgotStep1 />;
			case 2:
				return <ForgotStep2 />;
			case 3:
				return <ForgotStep3 />;
			default:
				return null;
		}
	}, [step, loginBlockedReason]);

	return <ForgotContentContainer loading={loading}>{ActiveForgotStep}</ForgotContentContainer>;
};
